import React from 'react';
import { ButtonV2, Flex } from '@withjoy/joykit';
import { Eye, Trash } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { ResponsiveMenuV2 } from '@shared/components/ResponsiveMenuV2';
import { useTranslation } from '@shared/core';
import type { StayZoneAreaData } from '../StayZoneTile.types';
import { ReactComponent as IconDots } from '@assets/icons/icon-dots.svg';

interface MenuProps
  extends Readonly<{
    stayZone: StayZoneAreaData;
    onView: (stayZone: StayZoneAreaData) => void;
    onRemove: (stayZone: StayZoneAreaData) => void;
  }> {}

export const Menu: React.FC<MenuProps> = ({ stayZone, onView, onRemove }) => {
  const { tq } = useTranslation('accommodationsAdmin');

  return (
    <ResponsiveMenuV2
      placement="bottomEnd"
      popperOptions={{
        offset: {
          offset: [-4.5, -1],
        },
      }}
    >
      <ResponsiveMenuV2.Trigger>
        <ButtonV2
          variant="ghost"
          intent="neutral"
          size="sm"
          width={pxToRem(40)}
          minWidth={pxToRem(40)}
          height={pxToRem(40)}
          borderRadius="50%"
          border="1px solid"
          borderColor="mono3"
          padding={0}
          aria-label={tq`Menu`}
        >
          <IconDots size={16} />
        </ButtonV2>
      </ResponsiveMenuV2.Trigger>
      <ResponsiveMenuV2.Content>
        <ResponsiveMenuV2.Item onClick={() => onView(stayZone)}>
          <Flex
            alignItems="center"
            gap={3}
          >
            <Eye size="md" />
            {tq`Explore`}
          </Flex>
        </ResponsiveMenuV2.Item>
        <ResponsiveMenuV2.Item onClick={() => onRemove(stayZone)}>
          <Flex
            alignItems="center"
            gap={3}
          >
            <Trash size="md" />
            {tq`Remove`}
          </Flex>
        </ResponsiveMenuV2.Item>
      </ResponsiveMenuV2.Content>
    </ResponsiveMenuV2>
  );
};
